var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-content',[_c('s-banner'),_c('div',{staticClass:"recharge"},[_c('div',{staticClass:"product-description"},[_c('p'),_c('p',[_vm._v("请选择需要购买的套餐")]),_c('p')]),_c('s-product-list',{on:{"purchase":_vm.purchase}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }